import { IconProps } from './IconProps';

export const StarGlare = ({ className, style }: IconProps) => {
  return (
    <svg
      className={className}
      style={style}
      width="77"
      height="72"
      viewBox="0 0 77 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.4" filter="url(#filter0_f_1951_659)">
        <path
          d="M36.6668 9.60514L37.4171 30.941L60.1707 5L38.5668 31.9054L72.6769 26.6544L38.8274 33.3828L68.3335 51.279L38.077 34.6821L42.1602 49.3054L36.6668 35.1952L24.1606 67.3515L35.2565 34.6821L5 51.279L34.5062 33.3828L19.042 30.941L34.7668 31.9054L13.1628 5L35.9164 30.941L36.6668 9.60514Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_1951_659"
          x="0.784062"
          y="0.784062"
          width="76.1116"
          height="70.7834"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="2.10797"
            result="effect1_foregroundBlur_1951_659"
          />
        </filter>
      </defs>
    </svg>
  );
};
